export default "__VITE_ASSET__CChUGu4v__"